import { useNavigate } from 'react-router-dom'

import { Button, Text, Signal } from '@interco/inter-toranja'
import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import { Header } from '@/components'
import { RoutesNames } from '@/routes/routes'
import { BridgeService } from '@/services'

import * as S from './styles'

export const FeedbackError = () => {
  const navigate = useNavigate()

  return (
    <S.Container>
      <Header
        onBackClick={() => {
          BridgeService.interWbNavigate.requestGoBack()
        }}
      />

      <S.ImageContainer>
        <Signal variant="information" state="enabled" size="large" />
      </S.ImageContainer>
      <S.TextContainer data-testid="title">
        <Text
          textSize={TextSize.Large}
          textType={TextType.Title}
          textWeight={TextWeight.Bold}
          as="h1"
        >
          Houve um erro por aqui
        </Text>

        <Text
          textSize={TextSize.Medium}
          textType={TextType.Body}
          textWeight={TextWeight.Regular}
          as="span"
        >
          Funcionalidade temporariamente indisponível. Por favor, tente novamente.
        </Text>
      </S.TextContainer>

      <S.Footer>
        <Button
          data-testid="button-try-again"
          label="Tentar novamente"
          onClick={() => {
            navigate({
              pathname: RoutesNames.ROOT,
            })
          }}
        />
      </S.Footer>
    </S.Container>
  )
}
